export default __webpack_public_path__ + "static/media/150x150_03.10d4170c.jpg";